import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-display text-background-50 mb-4">
              非麻瓜漫画
            </h4>
            <p className="text-sm leading-relaxed text-foreground-400">
              专业的免费韩漫在线阅读平台，致力于为您提供最新、最全的韩国漫画资源。采用无缝下拉式观看模式，让阅读体验更加流畅舒适。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              更多分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 非麻瓜漫画 FeiMaGua.com - 免费韩漫在线阅读网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors text-sm" rel="nofollow">
              <i className="ri-wechat-line mr-1"></i>微信公众号
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors text-sm" rel="nofollow">
              <i className="ri-weibo-line mr-1"></i>微博
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}